import { render, staticRenderFns } from "./my-news.vue?vue&type=template&id=2a7efeaf&scoped=true"
import script from "./my-news.vue?vue&type=script&lang=js"
export * from "./my-news.vue?vue&type=script&lang=js"
import style0 from "./my-news.vue?vue&type=style&index=0&id=2a7efeaf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7efeaf",
  null
  
)

export default component.exports